module.exports = __webpack_public_path__ + "assets/img/053363e012152cf5633479db707785f6.png";